import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { FormSpy } from 'react-final-form';

import { checkAddressErrors } from 'utils';

const propTypes = {
  namespace: PropTypes.string,
  setAreComponentsRendered: PropTypes.func.isRequired,
  isRequired: PropTypes.bool,
  countryCodeFieldName: PropTypes.string,
};

const defaultProps = {
  namespace: null,
  isRequired: true,
  countryCodeFieldName: null,
};

function AutoExpandEffect({ submitFailed, errors, values, namespace, isRequired, countryCodeFieldName, setAreComponentsRendered }) {
  const hasExpandedRef = useRef(false);

  const hasErrors = checkAddressErrors(namespace, errors, values, isRequired, countryCodeFieldName);

  useEffect(() => {
    if (submitFailed && hasErrors && !hasExpandedRef.current) {
      hasExpandedRef.current = true;
      setAreComponentsRendered(true);
    }
    if (!submitFailed) {
      hasExpandedRef.current = false;
    }
  }, [submitFailed, hasErrors, setAreComponentsRendered]);

  return null;
}

function AutoExpandOnError({ namespace, setAreComponentsRendered, isRequired, countryCodeFieldName }) {
  return (
    <FormSpy subscription={{ submitFailed: true, errors: true, values: true }}>
      {({ submitFailed, errors, values }) => (
        <AutoExpandEffect
          submitFailed={submitFailed}
          errors={errors}
          values={values}
          namespace={namespace}
          isRequired={isRequired}
          countryCodeFieldName={countryCodeFieldName}
          setAreComponentsRendered={setAreComponentsRendered}
        />
      )}
    </FormSpy>
  );
}

AutoExpandOnError.propTypes = propTypes;
AutoExpandOnError.defaultProps = defaultProps;

export default AutoExpandOnError;
